<div
  @fadeLeft
  *ngIf="canShowWorkflow && (status$ | async)"
  class="menu-workflow menu"
>
  <ng-scrollbar orientation="vertical">
    <menu-workflow-content
      [viewMode]="'sidebar'"
      [pageId]="pageId"
      [homepageId]="homepageId"
      (closeSidebar)="onCloseWorkflow()"
    />
  </ng-scrollbar>
</div>
